<button 
  nz-button 
  nzType="primary" 
  nzShape="circle" 
  class="build-info-btn"
  nz-tooltip
  nzTooltipTitle="Build Details"
  (click)="openBuildDetails()">
  <i nz-icon nzType="info"></i>
</button>
